import React, { useEffect, useState } from 'react';
import classes from "./FindingOpponent.module.css";
import Header from '../components/Header';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaArrowLeft } from "react-icons/fa6";
import { useTranslation } from 'react-i18next';
import { getAllOpponent } from '../http/http';
import { useDispatch, useSelector } from 'react-redux';
import { resetUserScore, setUser } from '../store/slices/userPlayerSlice';
import { resetOpponentScore, setOpponent } from '../store/slices/opponentPlayerSlice';
import { ResetTime } from '../store/slices/timeSlice';
import { resetQuestions } from '../store/slices/questionsSlice';
import { ResetIndex } from '../store/slices/indexSlice';
import MediumLoader from '../components/Loaders/MediumLoader';
import { removeUserToken } from '../store/slices/userTokenSlice';
import { toast } from 'react-toastify';

const FindingOpponentReverseQuiz = () => {
    const navigate = useNavigate();
    const { userToken } = useSelector(state => state.persisted.userTokenSlice);
    const { opponent } = useSelector(state => state?.persisted?.opponentPlayerSlice);
    const { user } = useSelector(state => state?.persisted?.userPlayerSlice);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const location = useLocation();

    const { selectedLanguage } = useSelector(state => state.languageSlice);

    const [loading, setLoading] = useState(true);

    const fetchOpponent = async () => {
        try {
            setLoading(true);
            const response = await getAllOpponent(userToken);
            dispatch(setOpponent(response?.data?.result?.opponent));
            dispatch(setUser(response?.data?.result?.user));
            setTimeout(() => {
                setLoading(false);
            }, 1000);
        } catch (error) {

            if (error?.response?.status == 403) {
                dispatch(removeUserToken());
                toast.error(t("52"));
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.error?.error || error?.response?.error?.error || error?.response?.error || "Something Went Wrong!");
            }
        }
    }

    useEffect(() => {
        fetchOpponent();
    }, []);

    const handleNavigateToPlayQuiz = () => {
        dispatch(ResetTime());
        dispatch(resetQuestions());
        dispatch(ResetIndex());
        dispatch(resetOpponentScore());
        dispatch(resetUserScore());

        navigate("/reverse-quiz/game", {
            state: location?.state
        })
    }

    return (
        <>
            <Header hideLanguage={true} />

            <div className={classes.container}>

                <div className={classes.header_section}>
                    <div className={classes.back_button} onClick={() => {
                        navigate("/home");
                    }}>
                        <FaArrowLeft className={classes.back_icon} />
                    </div>

                    <h2 className={classes.header_text}>{t("34")}</h2>
                </div>

                <div className={classes.section_users}>
                    <div className={classes.section_user}>
                        <img src={user?.image ?? "/assets/images/dummy.png"} alt={user?.name ?? t("1")} className={classes.user_image} />
                        <p className={classes.user_name}>{t("1")}</p>
                    </div>

                    <div className={classes.section_versus}>
                        <p className={classes.versus_text}>{t("35")}</p>
                    </div>

                    {loading ? <div>
                        <MediumLoader />
                        <p className={classes.opponent_name}>{t("36")}</p>
                    </div> : (
                        <div className={classes.section_opponent}>
                            <img src={opponent?.image ?? "/assets/images/dummy.png"} alt={opponent?.name} className={classes.opponent_image} />
                            <p className={classes.opponent_name}>{opponent?.name ?? t("17")}</p>
                        </div>
                    )}
                </div>

                <p className={classes.desc_text}>{loading ? t("37") : t("38")}</p>

                <button className={classes.play_button} onClick={handleNavigateToPlayQuiz}
                >
                    {t("16")}
                </button>
            </div>
        </>
    )
}

export default FindingOpponentReverseQuiz;